// extracted by mini-css-extract-plugin
export var adjacentSlide = "_px-9";
export var arrowButtonContainer = "_px-5";
export var arrowButtonIcon = "_px-6";
export var carouselArrowButton = "_px-2";
export var carouselElementContainer = "_px-1";
export var currentSlide = "_px-8";
export var left = "_px-3";
export var otherSlide = "_px-a";
export var productCarouselContainer = "_px-0";
export var right = "_px-4";
export var sliderOverflow = "_px-7";